(function () {
  'use strict';

  angular
    .module('app.rankingScoreReportInformation')
    .controller('rankingScoreReportInformationCtrl', ['measureService', 'rankingScoreReportInformationService', '$scope','$rootScope','$http','$filter','filterFilter', '$state',
                                    function (measureService, rankingScoreReportInformationService, $scope, $rootScope, $http, $filter, filterFilter, $state) {

      function generateInfluencerInfo(influencerInfo) {

        var influencer_login_summary = $rootScope.currentUser;
        var current_influencer = $rootScope.influencerInformation;

        var influencer_info = {
          name: "",
          country_flag: "",
          profile_picture_url: ""
        };
        influencer_info.name = current_influencer.name;
        influencer_info.country_flag = "images/country-flag/" + current_influencer.country.name + ".png";
        if(influencer_login_summary.image == null){
          influencer_info.profile_picture_url = "images/NoImage.png";
        } else{
          influencer_info.profile_picture_url = $rootScope.apiUrl + 'uploads/profile/' + influencer_login_summary.image;
        }
        
        var overall = {
          name: "overall"
        };
        overall.value = influencerInfo.ranking_number;
        overall.percent = Math.abs(influencerInfo.ranking_change);
        if(influencerInfo.ranking_change >= 0){
          overall.status = "asc";
        } else {
          overall.status = "desc";
        }
        overall.total_influencer = influencerInfo.total_influencer;
        overall.description = "Out of " + influencerInfo.total_influencer + " Influencers";

        var posts = {
          name: "posts"
        };
        posts.value = influencerInfo.post_number;
        posts.percent = Math.abs(influencerInfo.post_change.toFixed(1));
        if(influencerInfo.post_change >= 0){
          posts.status = "asc";
        } else{
          posts.status = "desc";
        }
        posts.avg_posts = influencerInfo.avg_post.toFixed(1);
        posts.description = "Average " + influencerInfo.avg_post.toFixed(1) + " posts per day";

        var influencer_score = {
          name: "influencer score",
          icon: "images/ico/Trophy Logo.png"
        };
        influencer_score.value = influencerInfo.influencer_score;
        influencer_score.influencer_rate = influencerInfo.ranking_score;
        var top_temp = 1;
        var influencerRate = influencerInfo.ranking_score;
        while(influencerRate >= 10){
          influencerRate = influencerRate / 10;
          top_temp = top_temp * 10;
        }
        if(influencer_score.influencer_rate % top_temp > 0){
          influencer_score.top_influencer = (Math.round(influencerRate) + 1) * top_temp;
        } else{
          if(top_temp == 1) {
            influencer_score.top_influencer = 10;
          } else {
            influencer_score.top_influencer = Math.round(influencerRate) * top_temp;
          }
        }
        
         
        influencer_score.description = "Among Top " + influencer_score.top_influencer + " Influencers";

        var influencer_infomation_total = [];
        influencer_infomation_total.push(influencer_info);
        influencer_infomation_total.push(overall);
        influencer_infomation_total.push(posts);
        influencer_infomation_total.push(influencer_score);

        $scope.influencerInformation = influencer_infomation_total;    
      }

      function getDataRankingScoreReportInformation(args) {
        var currentInfluencer = $rootScope.currentInfluencer;
        if(currentInfluencer == null || !currentInfluencer.influencerChannels == null || currentInfluencer.influencerChannels.length == 0) {
          return;
        }
        var params = {
                mention : 0,
                blog_id : 0,
                project_id : 0,
                channel: currentInfluencer.influencerChannels[0].id
            };
        params.date = args.date ? args.date.value : $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;
        
        getInfluencerInformation(params);
      }

      function getInfluencerInformation(params) {
        rankingScoreReportInformationService.getInfluencerInformation(params)
          .then(function (response) {
            generateInfluencerInfo(response.data.influencer_summary);
          })
          .catch(function (msg) {
            $scope.influencerInformation = [];
          })
          .finally(function () {
            $rootScope.$broadcast('sectionLoaded');
          });
      }

      // first initiating
      getDataRankingScoreReportInformation({});
      
    }]);

})();